import { createSlice } from '@reduxjs/toolkit'
import { CollectionSite } from 'models';
import { createInitialSlice } from 'store/utils';
import { createListAsyncThunk, GenericListSelectorResult, getStateListEntities, getStateListMetas } from 'store/factory';
import { getCollectionSitesAsync, ListByAgencyGroupArgs } from 'services/agency-groups';

// DEFINITION
const sliceConfiguration = {
  name: 'collectionSites',
};
const initialState = createInitialSlice<CollectionSite>();

// THUNKS
const fetchCollectionSites = createListAsyncThunk<CollectionSite, ListByAgencyGroupArgs>(getCollectionSitesAsync, { ...sliceConfiguration, type: 'fetchCollectionSites' });

export { fetchCollectionSites };

// SLICE
const slice = createSlice({
  ...sliceConfiguration,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    fetchCollectionSites.addCasesTo?.(builder);
  },
});

export default slice.reducer;

// SELECTORS
export const getCollectionSites = (state: any): GenericListSelectorResult<CollectionSite> => {
  const { status, ids, meta, error } = getStateListMetas<CollectionSite>(state, 'all', sliceConfiguration);
  const entities = getStateListEntities<CollectionSite>(state, ids, sliceConfiguration);
  return [entities, { ...meta, status }, error];
};